import WRAP from "WRAP-JS";

/* eslint-disable */
WRAP.Renderer.Airport = function() {
  WRAP.Renderer.GeoJSONExt.call(this);

  function addFeature(layer, feature, geo, data) {
    feature.geo = geo;
    feature.data = data;
    layer.addFeature(feature);
  }

  const superDraw = this.draw;
  const superDrawFeature = this.drawFeature;
  let labelTarget;
  let mask;
  this.draw = function(layer, content, conf, context, style, data, revision, dl) {

    //リビジョン & 言語 & timezone 変化チェックを追加
    var noChange = true;
    if ( this.content_revision !== revision.content) {
      noChange = false;
    } else if (this.context_revision !== revision.context) {
      noChange = false;
    } else if (this.conf_revision !== revision.conf) {
      noChange = false;
    } else if (this.style_revision !== revision.style) {
      noChange = false;
    } else if (this.data_revision !== revision.data) {
      noChange = false
    } else if (this.timeZone !== WRAP.Core.timezone) {
      noChange = false
    }

    if (noChange) {
      return;
    }

    labelTarget = conf.Attributes.label_target;
    mask = new WRAP.Geo.Mask(WRAP.Geo.currentView());
    mask.clear();
    superDraw.apply(this, arguments);

    this.content_revision = revision.content;
    this.context_revision = revision.context;
    this.conf_revision = revision.conf;
    this.style_revision = revision.style;
    this.data_revision = revision.data;
    this.timeZone = WRAP.Core.timezone;
  }

  this.drawFeature = function(layer, item, prop, ts) {
    superDrawFeature.apply(this, arguments);

    if (ts.label_min_zoom === undefined || ts.label_min_zoom <= WRAP.Geo.getZoom()) {
      this._drawFeatureImpl(layer, item, prop, ts);
    }
  }

  this._drawFeatureImpl = function(layer, item, prop, ts) {
    const geo = item;
    const style = ts;
    const text = prop[labelTarget || style.label_target];
    const s = Object.assign({
      font_size: 10,
      label_color: "rgb(76, 76, 76)",
    }, style);
    if (text !== undefined) {
      const textSize = WRAP.Geo.getTextMetrics(text, s.font_size);
      const width = textSize[0];
      const height = textSize[1];

      const point = geo.geometry.coordinates;
      const offsetX = -width/2;
      const offsetY = style.height + style.offset_y  + height;
      if (!mask.intersectRect(point, offsetX, offsetY, width, height)) {
        mask.addRect(point, offsetX, offsetY, width, height);

        //ラベル
        const label = new WRAP.Geo.Feature.Text({
          point: point,
          offsetX: 0,
          offsetY: offsetY,
          text: text,
          fontSize: s.font_size,
          fillStyle: s.label_color,
          strokeStyle: false,
          align: 'center',
        });
        addFeature(layer, label, geo, {type:'label', id:text});
      }
    }
  }
};
/* eslint-enable */